module.exports = __webpack_public_path__ + "img/logo-feder.a43fe78a.png";